import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";
import StatefulMultiSelect from "@khanacademy/react-multi-select";
import DriversPowerSelect from '../drivers/drivers-power-select.jsx';

export default class JobsDetailsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            play: false,
            isLoading: false,
            selectedStartDate: new Date(),
            selectedEndDate: new Date(),
            getReportUrl: '/api/v1/portal/portal-admin/job-details-report/',
            dailyDeliveredCarReportData: [],
            selected: [],
            downloadFileName:"Job Details Report",
            drivers:[],
            selectedDrivers:[]
        };
        this.handleDeliveredDateCalenderChange = this.handleDeliveredDateCalenderChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDailyDeliveredCarReportGeneration = this.handleDailyDeliveredCarReportGeneration.bind(this);
        this.handleDriverSelection = this.handleDriverSelection.bind(this);
    }
    componentDidMount() {
        let options = [];  
        this.setState({isLoading: true}); 
        return fetch("/api/v1/portal/drivers/all/for-dropdown-menu", {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((driver)=>{
                options.push({
                    label : driver.company.short_name+' - '+driver.full_name,
                    value : driver.driver_id
                });
            });
            this.setState({
                drivers: options,
                isLoading: false
            });
          });
        });
    }
    handleDeliveredDateCalenderChange(date) {
        this.setState({
            selectedStartDate: date
        });
    }
    handleEndDateChange(date) {
        this.setState({selectedEndDate: date})
    }
    handleDriverSelection(selectedDrivers) {
        this.setState({selectedDrivers});
    }
    handleDailyDeliveredCarReportGeneration(e) {
        this.setState({
            isLoading: true
        })
        let dailyDeliveredLogData = {};
        dailyDeliveredLogData.selectedStartDate = moment(this.state.selectedStartDate).format("YYYY-MM-DD");
        dailyDeliveredLogData.selectedEndDate = moment(this.state.selectedEndDate).format("YYYY-MM-DD");

        let url = this.state.getReportUrl + dailyDeliveredLogData.selectedStartDate+'/'+dailyDeliveredLogData.selectedEndDate;

        return fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
            body: JSON.stringify({
                driver_ids: this.state.selectedDrivers,
            }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                this.setState({
                    dailyDeliveredCarReportData: response,
                    isLoading: false
                })
            });
        }).catch((e)=>{
            alert(e);
        });
    }
    download(filename, text) {
        filename = filename + " From " + moment(this.state.selectedStartDate).format("YYYY-MM-DD") + " To " + moment(this.state.selectedEndDate).format("YYYY-MM-DD") + '.csv';
        let reportData = "";
        $('.daily-delivered-report-tbl tr').each(function () {
            $(this).find('td').each(function () {
                reportData += ($(this).text().replace(',', '')) + ',';
            });
            reportData += '\n';
        });
        reportData = reportData.replace(/,\s*$/, "");
        text = text + reportData;

        // Add BOM for Excel UTF-8 support
        let BOM = "\uFEFF";
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(BOM + text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    render() {
        let deliveredCars = [];
        const {selectedDrivers} = this.state;
        let downloadableCsvDataDelivered = "JOB REF,REG/VIN,CUSTOMER,TYPE OF MOVEMENT,COLLECTION ADDRESS,COLLECTION POSTCODE,DELIVER ADDRESS,DELIVER POSTCODE,STATUS,DELIVERY DATE,MILEAGE,UNIT PRICE,INVOICE DATE,INVOICE NUMBER";
        let expensesRows = [], expensesCols = [], totalExpenseLength = 0;
        if (this.state.dailyDeliveredCarReportData.length > 0) {
            this.state.dailyDeliveredCarReportData.map((currentJob, index) => {
                totalExpenseLength = (currentJob.expense_approvals != null) ? (totalExpenseLength < currentJob.expense_approvals.length) ? currentJob.expense_approvals.length : totalExpenseLength : 0;
            });
        }

        /* create expense column dynamic */
        if (totalExpenseLength > 0) {
            for (let k = 1; k <= totalExpenseLength; k++) {
                expensesCols.push(
                    <th key={k}>FUEL {k}</th>
                );
                downloadableCsvDataDelivered = downloadableCsvDataDelivered + ',' + "FUEL" + k;
            }
        }
        expensesCols.push(
            <th key="unit-cost-fuel">UNIT COST + FUEL</th>
        );
        downloadableCsvDataDelivered = downloadableCsvDataDelivered + ",UNIT COST + FUEL";
        if (this.state.dailyDeliveredCarReportData.length > 0) {
            let finalTotal = 0;
            this.state.dailyDeliveredCarReportData.map((currentJob, index) => {
                let mileage = currentJob.distance_in_miles;
                let FuelExpense = 0;
                expensesRows = [];
                if (totalExpenseLength > 0) {
                    if ((currentJob.expense_approvals != null && currentJob.expense_approvals.length > 0)) {
                        currentJob.expense_approvals.map((expense, key) => {

                            if (expense.client_charge_in_pence != 0) {
                                let netAmount = (expense.cost_in_pence / 1.2);
                                FuelExpense = FuelExpense + netAmount;

                                netAmount = (netAmount / 100).toFixed(2);

                                expensesRows.push(
                                    <td key={key}>&pound;{netAmount}</td>
                                );
                            } else {
                                expensesRows.push(
                                    <td key={key}>&nbsp;</td>
                                );
                            }

                        });
                        FuelExpense = FuelExpense / 100;
                        if (expensesRows.length != totalExpenseLength) {
                            let remainingCols = (totalExpenseLength) - (expensesRows.length);
                            for (let j = 1; j <= remainingCols; j++) {
                                expensesRows.push(
                                    <td key={"no-expense" + j + currentJob.id}>&nbsp;</td>
                                );
                            }
                        }
                    }
                    for (let k = 1; k <= totalExpenseLength; k++) {

                        if ((currentJob.expense_approvals != null && currentJob.expense_approvals.length > 0)) {
                            { expensesRows }
                        } else {
                            expensesRows.push(
                                <td key={k}>&nbsp;</td>
                            );
                        }
                    }
                }
                let unitCost = parseFloat(currentJob.job_price) + parseFloat(FuelExpense);
                finalTotal = finalTotal + unitCost;
                unitCost = unitCost.toFixed(2);
                expensesRows.push(
                    <td key="Unit-cost-{index}">&pound;{unitCost}</td>
                );
                let joburl = "/jobs/view/" + currentJob.id;
                let movementType = (currentJob.type_of_movement);
                let status = 'DELIVERED';
                let selectedDate = (currentJob.driver_completed_at) ? currentJob.driver_completed_at : this.state.selectedStartDate;
                if (currentJob != null) {

                    deliveredCars.push(
                        <tr key={index}>
                            <td><a href={joburl}>{currentJob.id}</a></td>
                            <td>
                                {currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}
                            </td>
                            <td>
                                {currentJob.customer.name}
                            </td>
                            <td className='to-up'>{movementType}</td>
                            <td>
                                {currentJob.pickup_address.address_line_1}
                            </td>
                            <td>
                                {currentJob.pickup_address.postcode}
                            </td>
                            <td>
                                {currentJob.dropoff_address.address_line_1}
                            </td>
                            <td>
                                {currentJob.dropoff_address.postcode}
                            </td>
                            <td>{status}</td>
                            <td>{moment(selectedDate).format("DD.MM.YY")}</td>
                            <td>{mileage}</td>
                            <td>&pound;{currentJob.job_price}</td>
                            <td>{(currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : ""}</td>
                            <td>{currentJob.invoice_number}</td>
                            {expensesRows}
                        </tr>
                    );

                }

            });
            
        } else {
            deliveredCars.push(
                <tr key='no-records'><td colSpan="15" className='text-center'>No Records</td></tr>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h2>Job Details Report</h2>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-1 col-sm-12">
                        <label><h5>Select From Date</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleDeliveredDateCalenderChange} selected={this.state.selectedStartDate} />
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select To Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.selectedEndDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Drivers</h5></label><br />

                        {/* <DriversPowerSelect handleDriverSelection={this.handleDriverSelection}/> */}

                        <div>
                            <StatefulMultiSelect
                                options={this.state.drivers}
                                selected={selectedDrivers}
                                onSelectedChanged={this.handleDriverSelection}
                                overrideStrings={{
                                    selectSomeItems: "Select Drivers...",
                                    allItemsAreSelected: "All Drivers are Selected",
                                    selectAll: "Select All",
                                    search: "Search Driver",
                                }}
                                />
                        </div>

                    </div>
                    <div className="col-md-2 col-sm-12">
                        <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={this.handleDailyDeliveredCarReportGeneration}>
                            <i className="fa fa-save"></i> Generate Job Details Report
                </button>
                    </div>
                    <div className="col-md-2 col-sm-12">
                        <button className="btn btn-primary btn-lg invoiced-btn-margin"
                            onClick={(e) => {
                                this.download(this.state.downloadFileName, downloadableCsvDataDelivered);
                            }}>
                            <i className="fa fa-download"></i> Download for Spreadsheet
                </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>Type of Movement</th>
                                        <th>Collection Address</th>
                                        <th>Collection Postcode</th>
                                        <th>Deliver Address</th>
                                        <th>Deliver Postcode</th>
                                        <th>Status</th>
                                        <th>Delivery Date</th>
                                        <th>Mileage</th>
                                        <th>Unit Price</th>
                                        <th>Invoice Date</th>
                                        <th>Invoice Number</th>
                                        {expensesCols}
                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.isLoading ?
                                        (<tr><td colSpan="15"><span className="add-loading-text">
                                            <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                        deliveredCars
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-jobs_raised_by_user_report')) {
    ReactDOM.render(
        <JobsDetailsReport message_if_none='Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-jobs_raised_by_user_report')
    );
}
